// Set of helper functions to facilitate wallet setup

import { ExternalProvider } from '@ethersproject/providers'
import { ChainId } from '@pancakeswap/sdk'
import { BAD_SRCS } from 'components/Logo/Logo'
import { EXPLORER_URLS } from 'config'
import {
  OP_MAINNET_URLS,
  HEIF_LAYER_RPC_URLS,
  OP_SEPOLIA_TESTNET_RPC_URLS, POLYGON_RPC_URLS,
  SEPOLIA_TESTNET_RPC_URLS, ARBITRUM_ONE_RPC_URLS, BASE_RPC_URLS
} from '../config/constants/rpc'

const NETWORK_CONFIG = {
  [ChainId.OP_MAINNET]: {
    name: 'WETH Smart Chain Mainnet',
    scanURL: EXPLORER_URLS[ChainId.OP_MAINNET],
    rpcUrls: OP_MAINNET_URLS,
  },
  [ChainId.OP_SEPOLIA]: {
    name: 'WETH Smart Chain Testnet',
    scanURL: EXPLORER_URLS[ChainId.OP_SEPOLIA],
    rpcUrls: OP_SEPOLIA_TESTNET_RPC_URLS,
  },
  [ChainId.SEPOLIA]: {
    name: 'WETH Smart Chain Testnet',
    scanURL: EXPLORER_URLS[ChainId.SEPOLIA],
    rpcUrls: SEPOLIA_TESTNET_RPC_URLS,
  },
  [ChainId.HEIF_LAYER]: {
    name: 'WETH Smart Chain Testnet',
    scanURL: EXPLORER_URLS[ChainId.HEIF_LAYER],
    rpcUrls: HEIF_LAYER_RPC_URLS,
  },
  [ChainId.POLYGON]: {
    name: 'WETH Smart Chain Testnet',
    scanURL: EXPLORER_URLS[ChainId.POLYGON],
    rpcUrls: POLYGON_RPC_URLS,
  },
  [ChainId.ARBITRUM_ONE]: {
    name: 'WETH Smart Chain Testnet',
    scanURL: EXPLORER_URLS[ChainId.ARBITRUM_ONE],
    rpcUrls: ARBITRUM_ONE_RPC_URLS,
  },
  [ChainId.BASE]: {
    name: 'WETH Smart Chain Testnet',
    scanURL: EXPLORER_URLS[ChainId.BASE],
    rpcUrls: BASE_RPC_URLS,
  }
}

/**
 * Prompt the user to add BSC as a network on Metamask, or switch to BSC if the wallet is on a different network
 * @returns {boolean} true if the setup succeeded, false otherwise
 */
export const setupNetwork = async (chainId?: number, externalProvider?: ExternalProvider) => {
  const provider = externalProvider || window.ethereum
  console.log(chainId)
  if (!NETWORK_CONFIG[chainId]) {
    console.error('Invalid chain id')
    return false
  }
  if (provider) {
    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: `0x${chainId.toString(16)}` }],
      })
      return true
    } catch (switchError) {
      if ((switchError as any)?.code === 4902) {
        try {
          await provider.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: `0x${chainId.toString(16)}`,
                chainName: NETWORK_CONFIG[chainId].name,
                nativeCurrency: {
                  name: 'ETH',
                  symbol: 'ETH',
                  decimals: 18,
                },
                rpcUrls: NETWORK_CONFIG[chainId].rpcUrls,
                blockExplorerUrls: [`${NETWORK_CONFIG[chainId].scanURL}/`],
              },
            ],
          })
          return true
        } catch (error) {
          console.error('Failed to setup the network in Metamask:', error)
          return false
        }
      }
      return false
    }
  } else {
    console.error("Can't setup the BSC network on metamask because window.ethereum is undefined")
    return false
  }
}

/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @returns {boolean} true if the token has been added, false otherwise
 */
export const registerToken = async (
  tokenAddress: string,
  tokenSymbol: string,
  tokenDecimals: number,
  tokenLogo?: string,
) => {
  // better leave this undefined for default image instead of broken image url
  const image = tokenLogo ? (BAD_SRCS[tokenLogo] ? undefined : tokenLogo) : undefined

  const tokenAdded = await window.ethereum.request({
    method: 'wallet_watchAsset',
    params: {
      type: 'ERC20',
      options: {
        address: tokenAddress,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        image,
      },
    },
  })

  return tokenAdded
}

export const canRegisterToken = () =>
  typeof window !== 'undefined' &&
  (window?.ethereum?.isMetaMask ||
    window?.ethereum?.isTrust ||
    window?.ethereum?.isCoinbaseWallet ||
    window?.ethereum?.isTokenPocket)
